import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterControls = ({
  searchQuery,
  onSearchChange,
  lifecycleFilter,
  onLifecycleFilterChange,
  engagementFilter,
  onEngagementFilterChange,
  locationFilter,
  onLocationFilterChange,
  tagFilter,
  onTagFilterChange,
  onClearFilters,
  hasActiveFilters
}) => {
  const lifecycleOptions = [
    { value: '', label: 'All Stages' },
    { value: 'Lead', label: 'Lead' },
    { value: 'Active Buyer', label: 'Active Buyer' },
    { value: 'Under Contract', label: 'Under Contract' },
    { value: 'Closed', label: 'Closed' },
    { value: 'Past Client', label: 'Past Client' }
  ];

  const engagementOptions = [
    { value: '', label: 'All Levels' },
    { value: 'High', label: 'High Engagement' },
    { value: 'Medium', label: 'Medium Engagement' },
    { value: 'Low', label: 'Low Engagement' }
  ];

  const locationOptions = [
    { value: '', label: 'All Locations' },
    { value: 'Downtown', label: 'Downtown' },
    { value: 'Suburbs', label: 'Suburbs' },
    { value: 'Westside', label: 'Westside' },
    { value: 'Eastside', label: 'Eastside' },
    { value: 'Northside', label: 'Northside' }
  ];

  const tagOptions = [
    { value: '', label: 'All Tags' },
    { value: 'First Time Buyer', label: 'First Time Buyer' },
    { value: 'Investor', label: 'Investor' },
    { value: 'Luxury', label: 'Luxury' },
    { value: 'Referral', label: 'Referral' },
    { value: 'VIP', label: 'VIP' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        {/* Search */}
        <div className="flex-1 lg:max-w-md">
          <Input
            type="search"
            placeholder="Search clients by name or phone..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 lg:flex-1">
          <div className="flex-1 min-w-0">
            <Select
              placeholder="Lifecycle Stage"
              options={lifecycleOptions}
              value={lifecycleFilter}
              onChange={onLifecycleFilterChange}
            />
          </div>

          <div className="flex-1 min-w-0">
            <Select
              placeholder="Engagement Level"
              options={engagementOptions}
              value={engagementFilter}
              onChange={onEngagementFilterChange}
            />
          </div>

          <div className="flex-1 min-w-0">
            <Select
              placeholder="Location"
              options={locationOptions}
              value={locationFilter}
              onChange={onLocationFilterChange}
            />
          </div>

          <div className="flex-1 min-w-0">
            <Select
              placeholder="Tags"
              options={tagOptions}
              value={tagFilter}
              onChange={onTagFilterChange}
            />
          </div>
        </div>

        {/* Clear Filters */}
        {hasActiveFilters && (
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            className="whitespace-nowrap"
          >
            Clear Filters
          </Button>
        )}
      </div>
      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground">Active filters:</span>
          {lifecycleFilter && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
              Stage: {lifecycleFilter}
              <button
                onClick={() => onLifecycleFilterChange('')}
                className="hover:bg-primary/20 rounded-full p-0.5"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          {engagementFilter && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-accent/10 text-accent rounded-md text-sm">
              Engagement: {engagementFilter}
              <button
                onClick={() => onEngagementFilterChange('')}
                className="hover:bg-accent/20 rounded-full p-0.5"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          {locationFilter && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-secondary/10 text-secondary rounded-md text-sm">
              Location: {locationFilter}
              <button
                onClick={() => onLocationFilterChange('')}
                className="hover:bg-secondary/20 rounded-full p-0.5"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          {tagFilter && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-warning/10 text-warning rounded-md text-sm">
              Tag: {tagFilter}
              <button
                onClick={() => onTagFilterChange('')}
                className="hover:bg-warning/20 rounded-full p-0.5"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterControls;